import Axios from 'axios'
import {facilityMaintainanceUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_starts (context) {
    Axios.get(facilityMaintainanceUrls.getAllFacilityMaintainances).then(function (response) {
      context.commit('GET_ALL_FACILITY_MAINTAINANCES', response.data)
    })
  },
  get_starts (context, publicId) {
    Axios.get(facilityMaintainanceUrls.getFacilityMaintainances + publicId).then(function (response) {
      context.commit('GET_FACILITY_MAINTAINANCES', response.data)
    })
  },
  get_deleted_starts (context) {
    Axios.get(facilityMaintainanceUrls.getDeletedFacilityMaintainance).then(function (response) {
      context.commit('GET_DELETED_FACILITY_MAINTAINANCES', response.data)
    })
  },
  get_start (context, publicId) {
    Axios.get(facilityMaintainanceUrls.getFacilityMaintainance + publicId).then(function (response) {
      context.commit('GET_FACILITY_MAINTAINANCE', response.data)
    })
  },
  post_start (context, data) {
    Axios.post(facilityMaintainanceUrls.postFacilityMaintainance, data).then(function () {
      context.dispatch('get_all_starts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_start (context, data) {
    Axios.post(facilityMaintainanceUrls.editFacilityMaintainance, data).then(function () {
      context.dispatch('get_all_starts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_start (context, publicId) {
    Axios.get(facilityMaintainanceUrls.deleteFacilityMaintainance + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_FACILITY_MAINTAINANCES', response.data)
      router.push({
        name: 'Module.DeletedFacilityMaintainances'
      })
    })
  },
  restoreFacilityMaintainance (context, publicId) {
    Axios.get(facilityMaintainanceUrls.restoreFacilityMaintainance + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_MAINTAINANCES', response.data)
      router.push({
        name: 'Module.FacilityMaintainances'
      })
    })
  }
}
